<div class="custom-control custom-switch float-start" (click)="$event.stopPropagation()">
   <input *ngIf="enabled" type="checkbox" class="custom-control-input" name="harry" id="JBMSwitch{{id}}" [checked]="active" (click)="click();$event.stopPropagation()">
   <input *ngIf="!enabled" type="checkbox" class="custom-control-input" name="harry" [disabled]="true" id="JBMSwitch{{id}}" [checked]="active">
   <label *ngIf="label" class="custom-control-label" for="JBMSwitch{{id}}">{{label}}</label>
</div>
